module.exports = __webpack_public_path__ + "9bc7e20937bd375dcc27515e0d9e79ce.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/perks/backgrounds/maze.png
// module id = 3176
// module chunks = 0